var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("4、管理会计的服务对象侧重于（　）。")]),_vm._v("A、股东 "),_c('br'),_c('br'),_vm._v("B、外部集团"),_c('br'),_c('br'),_vm._v("C、债权人"),_c('br'),_c('br'),_vm._v("D、企业内部的经营管理 ")])
}]

export { render, staticRenderFns }